import { Italic, RotateCcw } from 'lucide-react'
import { ensureFontLoaded } from '../contexts/TextStyleContext'
import { FONT_OPTIONS, FONT_WEIGHT_OPTIONS } from '../utils/fonts'
import { TextStyle, TEXT_SIZE_OPTIONS } from '../utils/textStyles'

interface BlockStyleBarProps {
  value: TextStyle
  onChange: (style: TextStyle) => void
}

export const barSelectClass =
  'h-8 px-2 text-xs bg-white border border-gray-300 rounded-md text-[#2C2C2C] focus:outline-none focus:ring-2 focus:ring-[#7F1734]/30'

/** Style applique a TOUT le bloc de texte (taille, police, graisse, italique). */
export default function BlockStyleBar({ value, onChange }: BlockStyleBarProps) {
  const update = (patch: Partial<TextStyle>) => {
    if (patch.fontFamily) ensureFontLoaded(patch.fontFamily)
    onChange({ ...value, ...patch })
  }

  return (
    <span style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px' }}>
      <span style={{ fontSize: '11px', color: '#6E6659', minWidth: '78px' }}>Tout le texte</span>
      <select
        aria-label="Taille de tout le texte"
        value={value.fontSize ? String(value.fontSize) : ''}
        onChange={(e) => update({ fontSize: e.target.value ? Number(e.target.value) : undefined })}
        className={barSelectClass}
      >
        <option value="">Taille auto</option>
        {TEXT_SIZE_OPTIONS.map((size) => (
          <option key={size} value={size}>
            {size} px
          </option>
        ))}
      </select>
      <select
        aria-label="Police de tout le texte"
        value={value.fontFamily || ''}
        onChange={(e) => update({ fontFamily: e.target.value || undefined })}
        className={barSelectClass}
      >
        <option value="">Police du site</option>
        {FONT_OPTIONS.map((font) => (
          <option key={font.id} value={font.id}>
            {font.label}
          </option>
        ))}
      </select>
      <select
        aria-label="Graisse de tout le texte"
        value={value.fontWeight || ''}
        onChange={(e) => update({ fontWeight: e.target.value || undefined })}
        className={barSelectClass}
      >
        <option value="">Graisse auto</option>
        {FONT_WEIGHT_OPTIONS.map((weight) => (
          <option key={weight.id} value={weight.id}>
            {weight.label}
          </option>
        ))}
      </select>
      <button
        type="button"
        aria-label="Italique pour tout le texte"
        aria-pressed={!!value.italic}
        onClick={() => update({ italic: !value.italic })}
        className={`h-8 w-8 flex items-center justify-center rounded-md border transition-colors ${
          value.italic
            ? 'bg-[#7F1734] text-white border-[#7F1734]'
            : 'bg-white text-[#2C2C2C] border-gray-300 hover:bg-gray-50'
        }`}
      >
        <Italic size={14} />
      </button>
      <button
        type="button"
        aria-label="Reinitialiser le style de tout le texte"
        title="Revenir au style par defaut"
        onClick={() => onChange({})}
        className="h-8 w-8 flex items-center justify-center rounded-md border border-gray-300 bg-white text-[#2C2C2C] hover:bg-gray-50"
      >
        <RotateCcw size={14} />
      </button>
    </span>
  )
}
